(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dr-althea-345"] && !Shopify.designMode) return;
  try {
    (()=>{const root=document.querySelector('[data-section-id="{{ section.id }}"]');if(!root)return;const q=root.querySelector('input[name="quantity"]'),m=root.querySelector('[data-qty-minus]'),p=root.querySelector('[data-qty-plus]');if(q&&m&&p){m.addEventListener('click',()=>{q.value=Math.max(1,Number(q.value||1)-1)});p.addEventListener('click',()=>{q.value=Number(q.value||1)+1})}})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
